import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import TitleContentIntro from "@/components/TitleContentIntro.vue";
import MainContentIntro from "@/components/MainContentIntro.vue";
import GalleryMain from "@/components/GalleryMain.vue";
const UiMappers = Vue.extend({});
const DataMappers = Vue.extend({
    computed: {},
    methods: {},
});
let ContentIntro = class ContentIntro extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.slideImgs = [
            "/static/images/intro/activity-1.jpg",
            "/static/images/intro/malina-vert-25.jpg",
            "/static/images/intro/skills-1.jpg",
            "/static/images/intro/motivation-1.jpg",
            "/static/images/intro/malina-vert-26.jpeg",
            "/static/images/intro/events-1.jpg",
            "/static/images/intro/relax-1.jpg",
        ];
    }
};
ContentIntro = __decorate([
    Component({
        components: {
            GalleryMain,
            TitleContentIntro,
            MainContentIntro,
        },
    })
], ContentIntro);
export default ContentIntro;
